import { Component } from '@angular/core';
import { CountyService } from 'app/shared/county.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

const { version: appVersion,
        buildDate: buildDate
} = require('../../../package.json');

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.less']
})
export class AboutComponent {

  buildDate: string;
  appVersion: string;

  constructor(private bsModalRef: BsModalRef, 
              private countyService: CountyService) {
    this.appVersion = appVersion;
    this.buildDate = buildDate;
   }

   isICMSReleased() {
    if (this.countyService.getNonOdysseyCounties().length < 100) {
      return true;
    } else {
      return false;
    }
   }

 hideModal(): void {
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/about/about.component.ts